import {initProductFancybox} from '@/app/js/product/product-fancybox'
import {handleProductHtml} from '@/app/js/product/product-html'
import {initProductVideo} from '@/app/js/product/product-video'
import {initProducts} from '@/app/js/product/products'
import {initProductReviewForm, initProductReviews, initProductReviewsNew} from '@/app/js/product/product-reviews'
import {initProductShare} from '@/app/js/product/product-share'
import {initProductTips} from '@/app/js/product/product-tips'
import {fixedAddButton} from '@/app/js/product/fixed-add-button'

export function runProductScripts() {
  initProducts()
  initProductFancybox()
  initProductReviews()
  initProductReviewForm()
  initProductReviewsNew()
  handleProductHtml()
  initProductVideo()
  initProductShare()
  initProductTips()
  fixedAddButton()
}
